export async function copyAndShare(text) {
  await navigator.clipboard
    .writeText(text)
    .then(() => {
      if (navigator.share) {
        navigator
          .share({
            title: "Payment Link",
            text: "Here is your payment link:",
            url: text,
          })
          .then(() => console.log("Shared successfully"))
          .catch((error) => console.error("Error sharing:", error));
      } else {
        console.log("Web Share API not supported. Link copied to clipboard.");
      }
    })
    .catch((error) => console.error("Copy failed:", error));
}
